import { chooseReducer } from '@/utils/draftHelper';
import initialState from './state';
import updateRoleState from './role';
import updateRoleActionsState from '../roleactions/state/roleActions';
import updateTokensState from './tokens';
import updateConfigurationState from './configuration';

const handlers = {
  ...updateRoleState,
  ...updateRoleActionsState,
  ...updateTokensState,
  ...updateConfigurationState,
};

export default (state = initialState, action) => chooseReducer(state, action, handlers);
